module.exports = __webpack_public_path__ + "media/THE 4 imagination.4ad0867d.mp4";